/*
 * Jira Ticket:
 * Created Date: Fri, 21st Jan 2022, 17:19:27 pm
 * Author: Rafiul Ansari
 * Email: raf.ansari@thedistance.co.uk
 * Copyright (c) 2022 The Distance
 */

import { fetchStart, fetchEnd } from 'react-admin';

export default function getPendingInvites(
  id,
  { dataProvider, dispatch, setPendingInvites }
) {
  return () => {
    let isSubscribed = true;
    dispatch(fetchStart());
    //get user, if admin
    dataProvider('GET_ONE', 'User', {
     id
   }).then(result => {
     if (result.data.isAdmin) {
      setPendingInvites([])
     }
     else {
      dataProvider('GET_MANY_REFERENCE', 'Employment', {
        page: 1,
        perPage: 10,
        filter: {
          userId: id,
          status: 'PENDING',
        },
      })
        .then(result => {
          if (isSubscribed) {
            setPendingInvites(result.data);
          }
        })
        .catch(() => {})
        .finally(() => dispatch(fetchEnd()));
     }
     dispatch(fetchEnd())
   }).catch(e => {
     dispatch(fetchEnd())
     return notify(e.message,'warning')  
   })

    return () => (isSubscribed = false);
  };
}
